import { ExternalLink } from 'ngx-transloco-markup';
import { YattaLinkBase, isYattaLinkBase } from './yatta-link-base';

export type YattaExternalLanguageSpecificLinkUrl = (language: string) => string;

export function isYattaExternalLanguageSpecificLinkUrl(value: unknown): value is YattaExternalLanguageSpecificLinkUrl {
  return typeof value === 'function';
}

export type YattaExternalLinkUrl = string | YattaExternalLanguageSpecificLinkUrl;

export function isYattaExternalLinkUrl(value: unknown): value is YattaExternalLinkUrl {
  return typeof value === 'string' || isYattaExternalLanguageSpecificLinkUrl(value);
}

export interface YattaExternalLink extends Omit<ExternalLink, 'url'>, YattaLinkBase {
  url: YattaExternalLinkUrl;
}

export function isYattaExternalLink(value: unknown): value is YattaExternalLink {
  return (
    typeof value === 'object' &&
    value !== null &&
    'url' in value &&
    isYattaExternalLinkUrl(value.url) &&
    (!('target' in value) || value.target === undefined || typeof value.target === 'string') &&
    isYattaLinkBase(value)
  );
}

export const buildYattaExternalLink = (url: YattaExternalLinkUrl, target?: string, cssClass?: string, id?: string): YattaExternalLink => ({
  url,
  target,
  class: cssClass,
  id
});
